import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "flex gap-x-5"
}
const _hoisted_3 = { class: "flex flex-col gap-y-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_skeleton = _resolveComponent("v-skeleton")

  return ($data.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_skeleton, { class: "aspect-product h-[23rem] w-full" })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_skeleton, {
            rep: 5,
            class: "aspect-square h-12.5 w-full"
          })
        ]),
        _createVNode(_component_v_skeleton, { class: "aspect-product w-full bg-black-10" })
      ]))
}